<template>
  <div>
    <el-form
      ref="claim"
      :model="item"
      label-width="120px"
      :label-position="labelPosition"
      size="small"
      v-loading="loading"
    >
      <div class="col-12" v-if="approvalStatus" style="text-align: right">
        <el-button size="small" type="success" @click="approve">{{ $t('Təsdiq') }}</el-button>
        <el-button size="small" type="danger" @click="reject">{{ $t('İmtina') }}</el-button>
      </div>

      <el-tabs v-model="activeName" plane>
        <el-tab-pane :label="$t('Məlumat')" name="claim">
          <div class="d-flex justify-content-center" style="padding-bottom: 10px"></div>

          <br />
          <card>
            <el-form label-width="200px" :label-position="labelPosition" size="small">
              <div class="row">
                <div class="col-md-4 col-12">
                  <titles :text="$t('İş')"></titles>
                  <hr
                    width="85%"
                    size="50"
                    style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
                    align="left"
                  />
                  <span>#: {{ item.claimNumber }}</span>
                </div>

                <div class="col-md-4 col-12">
                  <titles text="Status"></titles>
                  <hr
                    width="85%"
                    size="50"
                    style="margin-top: 5px; position: relative;height: 1px;background: #F3EFE0;"
                    align="left"
                  />
                  <status-label
                    :type="claimParticipants.statusTypeId === 45
                      ? 'indigo'
                      : '' || claimParticipants.statusTypeId === 50
                        ? 'forestGreen'
                        : '' || claimParticipants.statusTypeId === 70
                          ? 'goldenrod'
                          : '' || claimParticipants.statusTypeId === 75
                            ? 'limeGreen'
                            : '' || claimParticipants.statusTypeId === 80
                              ? 'mediumBlue'
                              : '' || claimParticipants.statusTypeId === 95
                                ? 'greenYellow'
                                : '' || claimParticipants.statusTypeId === 110
                                  ? 'coral'
                                  : '' || claimParticipants.statusTypeId === 125
                                    ? 'salmon'
                                    : '' || claimParticipants.statusTypeId === 130
                                      ? 'olive'
                                      : '' || claimParticipants.statusTypeId === 131
                                        ? 'lightblue'
                                        : '' || claimParticipants.statusTypeId === 135
                                          ? 'forestGreen'
                                          : '' || claimParticipants.statusTypeId === 140
                                            ? 'greenYellow'
                                            : '' || claimParticipants.statusTypeId === 141
                                              ? 'goldenrod'
                                              : ''"
                  />
                  <span style="font-size: var(--font-primary);">{{ claimParticipants.statusTypeName }}</span>
                </div>
              </div>
            </el-form>
          </card>

          <el-collapse v-loading="loading" value="1">
            <el-collapse-item name="1">
              <template #title>
                <div style="margin-left: 7px;">
                  <i class="fa-solid fa-people-group"></i>
                  &nbsp;
                  <span>{{ $t('Hadisə_tərəfləri') }}</span>
                </div>
              </template>
              <claim-participant-base :value="claimParticipants" />
            </el-collapse-item>
          </el-collapse>

          <el-collapse v-loading="loading" value="2">
            <el-collapse-item name="2">
              <template #title>
                <div style="margin-left: 7px;">
                  <i class="fa-solid fa-circle-info"></i>
                  &nbsp;
                  <span>{{ $t('Məlumat') }}</span>
                </div>
              </template>

              <card>
                <el-form
                  disabled
                  label-width="200px"
                  :label-position="labelPosition"
                  size="small"
                  v-loading="claimLoading"
                >
                  <div class="row">
                    <div class="col-md-6 col-12">
                      <el-form-item
                        :label="$t('Sığorta_məbləği')"
                        v-if="oSdamageType !== 2 && item.insuranceType == 2"
                        prop="insuredSum"
                      >
                        <el-input type="number" v-model="item.insuredSum"></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="$t('Sığorta_haqqı')"
                        v-if="oSdamageType !== 2 && item.insuranceType === 2"
                        prop="premium"
                      >
                        <el-input type="number" v-model="item.premium"></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="$t('Ödənməmiş_sığorta_haqqı')"
                        v-if="oSdamageType !== 2 && item.insuranceType === 2"
                        prop="debt"
                      >
                        <el-input type="number" v-if="oSdamageType !== 2" v-model="item.debt"></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="$t('Avtomobilin_sığorta_dəyəri')"
                        v-if="oSdamageType !== 2 && item.insuranceType === 2"
                        prop="insuredCost"
                      >
                        <el-input type="number" v-model="item.insuredCost"></el-input>
                      </el-form-item>

                      <el-form-item :label="$t('ZBT')" prop="zbt">
                        <el-radio-group
                          @change="radioChange('zbt')"
                          :disabled="item.commChainAccident === 1 || item.commInjured === 1"
                          v-model="item.zbt"
                        >
                          <el-radio :label="1">{{ $t('Bəli') }}</el-radio>
                          <el-radio :label="0">{{ $t('Xeyr') }}</el-radio>
                        </el-radio-group>
                      </el-form-item>

                      <el-form-item :label="$t('Zəncirvari_qəza')" prop="chainAccident">
                        <el-radio-group
                          @change="radioChange('chainAccident')"
                          :disabled="item.zbt === 1"
                          v-model="item.chainAccident"
                        >
                          <el-radio :label="1">{{ $t('Bəli') }}</el-radio>
                          <el-radio :label="0">{{ $t('Xeyr') }}</el-radio>
                        </el-radio-group>
                      </el-form-item>

                      <el-form-item :label="$t('Xəsarət_alan')" prop="injured">
                        <el-radio-group
                          @change="radioChange('injured')"
                          :disabled="item.zbt === 1"
                          v-model="item.injured"
                        >
                          <el-radio :label="1">{{ $t('Var') }}</el-radio>
                          <el-radio :label="0">{{ $t('Yoxdur') }}</el-radio>
                        </el-radio-group>
                      </el-form-item>

                      <el-form-item :label="$t('Daxili_protokol')" prop="protocol">
                        <el-radio-group
                          @change="radioChange('protocol')"
                          :disabled="item.commInjured === 1"
                          v-model="item.protocol"
                        >
                          <el-radio :label="1">{{ $t('Bəli') }}</el-radio>
                          <el-radio :label="0">{{ $t('Xeyr') }}</el-radio>
                        </el-radio-group>
                      </el-form-item>

                      <el-form-item :label="$t('Subroqasiya')" prop="subragation">
                        <el-radio-group @change="radioChange('subragation')" v-model="item.subragation">
                          <el-radio :label="1">{{ $t('Bəli') }}</el-radio>
                          <el-radio :label="0">{{ $t('Xeyr') }}</el-radio>
                        </el-radio-group>
                      </el-form-item>

                      <el-form-item :label="$t('Ödənilmə_qaydası')" prop="paymentRule">
                        <el-select
                          style="width: 100%"
                          :placeholder="$t('Seçin')"
                          size="small"
                          v-model="item.paymentRule"
                        >
                          <el-option :label="$t('Kart')" :value="1"></el-option>
                          <el-option :label="$t('Bank_hesabı')" :value="2"></el-option>
                        </el-select>
                      </el-form-item>

                      <el-form-item :label="$t('Yekun_məbləğ')" prop="paymentSum">
                        <el-input
                          v-if="item.damageCategoryId === 2"
                          v-decimal
                          :disabled="true"
                          v-model="paymentSumComputed"
                        ></el-input>
                        <el-input v-else v-decimal v-model="item.paymentSum"></el-input>
                      </el-form-item>
                    </div>

                    <div class="col-md-6 col-12">
                      <el-form-item
                        :label="$t('Azadolma_məbləği')"
                        v-if="oSdamageType !== 2 && item.insuranceType === 2"
                        prop="deductible"
                      >
                        <el-input type="number" v-model="item.deductible"></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="$t('Əlavə_azadolma_məbləği')"
                        v-if="oSdamageType !== 2 && item.insuranceType === 2"
                        prop="deductibleAdd"
                      >
                        <el-input type="number" v-model="item.deductibleAdd"></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="$t('Ümumi_müqavilə_üzrə_borc')"
                        v-if="oSdamageType !== 2 && item.insuranceType === 2"
                        prop="contractDebt"
                      >
                        <el-input type="number" v-if="oSdamageType !== 2" v-model="item.contractDebt"></el-input>
                      </el-form-item>

                      <el-form-item
                        v-if="(item.paymentSum || item.paymentSum !== 0) && item.damageCategoryId !== 2"
                        :label="$t('Zərərçəkən_hər_iki_tərəf')"
                        prop="bothVictim"
                      >
                        <el-checkbox :true-label="1" :false-label="0" v-model="item.bothVictim"></el-checkbox>
                      </el-form-item>

                      <el-form-item :label="$t('NV_sayı')" prop="vehicleCount">
                        <el-input-number :disabled="item.zbt === 1" v-model="item.vehicleCount" :min="1" :max="10" />
                      </el-form-item>

                      <el-form-item :label="$t('Hadisənin_səbəbi')" prop="damageCategoryId">
                        <damage-categories :damageType="claimParticipants.osDamageType" v-model="item.damageCategoryId" />
                      </el-form-item>

                      <el-form-item
                        :label="$t('Xəsarətin_dərəcəsi')"
                        prop="medDamageType"
                        v-if="item.damageCategoryId === 2"
                      >
                        <med-damage-types v-model="item.medDamageType" />
                      </el-form-item>

                      <div style="display: flex;">
                        <div style="flex: 1; margin-right:-100px;">
                          <el-form-item>
                            <el-radio-group v-model="item.paymentPersonType">
                              <el-radio :label="1">{{ $t('FİN') }}</el-radio>
                              <el-radio :label="2">{{ $t('VÖEN') }}</el-radio>
                            </el-radio-group>
                          </el-form-item>
                        </div>

                        <div style="flex: 1.2">
                          <el-form-item prop="paymentIdentNumber">
                            <el-input id="search" v-model="item.paymentIdentNumber" style="width: 100%;">
                              <span slot="append">&nbsp;</span>
                              <el-button
                                class="primary"
                                size="small"
                                slot="append"
                                icon="el-icon-search"
                                @click="item.paymentPersonType === 1 ? onSearchAsan('PersonalInfo') : onSearchAsan('VoenInfo')"
                              ></el-button>
                            </el-input>
                          </el-form-item>
                        </div>
                      </div>

                      <el-form-item :label="$t('Faydalanan_şəxs')" prop="paymentReceivedPerson">
                        <el-input v-model="item.paymentReceivedPerson"></el-input>
                      </el-form-item>

                      <el-form-item :label="$t('Faydalananın_əlaqə_№')" prop="paymentReceivedPersonPhone">
                        <phone v-model="item.paymentReceivedPersonPhone" />
                      </el-form-item>

                      <!-- BURASI: computed label kullan -->
                      <el-form-item
                        v-if="item.damageCategoryId && item.damageCategoryId !== 1"
                        :label="getIdentLabelName"
                        prop="identNumber"
                      >
                        <el-input id="search" v-model="item.partIdentNumber" style="width: 100%;">
                          <span slot="append">&nbsp;</span>
                          <el-button
                            class="primary"
                            size="small"
                            slot="append"
                            icon="el-icon-search"
                            @click="onSearchPersonalInfo"
                          ></el-button>
                        </el-input>
                      </el-form-item>

                      <el-form-item
                        v-if="item.damageCategoryId && item.damageCategoryId !== 1"
                        :label="getPartPersonLabel"
                        prop="partPersonName"
                      >
                        <el-input v-model="item.partPersonName"></el-input>
                      </el-form-item>

                      <el-form-item
                        v-if="item.damageCategoryId && item.damageCategoryId !== 1"
                        :label="getPartPersonPhoneLabel"
                        prop="partPersonPhone"
                      >
                        <phone v-model="item.partPersonPhone" />
                      </el-form-item>

                      <el-form-item
                        v-if="item.damageCategoryId && item.damageCategoryId !== 1"
                        :label="$t('Əmlak_adı')"
                        prop="propertyName"
                      >
                        <el-input v-model="item.propertyName"></el-input>
                      </el-form-item>

                      <el-form-item
                        :label="$t('Sığorta_haqqının_ödəniş_tarixi')"
                        v-if="item.insuranceType === 2"
                        prop="payDate"
                      >
                        <el-date-picker
                          type="date"
                          :placeholder="$t('Sığorta_haqqının_ödəniş_tarixi')"
                          v-model="item.payDate"
                          style="width: 100%"
                        ></el-date-picker>
                      </el-form-item>
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12 col-12">
                      <el-form-item :label="$t('Əlavə_qeyd')" prop="otherDescr">
                        <el-input v-model="item.otherDescr" resize="none" type="textarea" :rows="2"></el-input>
                      </el-form-item>
                    </div>
                  </div>
                </el-form>
              </card>
            </el-collapse-item>
          </el-collapse>

          <el-collapse v-loading="loading">
            <el-collapse-item name="3">
              <template #title>
                <div style="margin-left: 7px;">
                  <i class="fa-solid fa-headphones-simple"></i>
                  &nbsp;
                  <span>{{ $t('Çağrı_mərkəzinin_qeydləri') }}</span>
                </div>
              </template>
              <accident-base :value="accItem"></accident-base>
            </el-collapse-item>
          </el-collapse>

          <el-collapse v-loading="loading">
            <el-collapse-item name="4">
              <template #title>
                <div style="margin-left: 7px;">
                  <i class="fa-solid fa-person-military-pointing"></i>
                  &nbsp;
                  <span>{{ $t('Komissarın_qeydləri') }}</span>
                </div>
              </template>
              <accident-comm-base :value="comm"></accident-comm-base>
            </el-collapse-item>
          </el-collapse>

          <el-collapse v-loading="loading">
            <el-collapse-item name="5">
              <template #title>
                <div style="margin-left: 7px;">
                  <i class="fa-solid fa-people-arrows-left-right"></i>
                  &nbsp;
                  <span>{{ $t('İştirakçılar') }}</span>
                </div>
              </template>

              <card>
                <el-form v-loading="partloading">
                  <div class="row">
                    <div class="col-md-6 col-12" v-for="p in participants" :key="p.id">
                      <div v-if="p.policyType === null || p.policyType === 1">
                        <participant-card
                          :item="p"
                          :readonly="true"
                          @refresh="getParticipants"
                          @edit="editParticipant(p)"
                          @delete="deleteParticipant"
                          @report="reportParticipant(p)"
                        />
                      </div>
                      <div v-else>
                        <other-participant-card
                          :item="p"
                          :readonly="true"
                          @refresh="getParticipants"
                          @edit="editParticipant(p)"
                          @delete="deleteParticipant"
                          @report="reportParticipant(p)"
                        />
                      </div>
                    </div>
                  </div>
                </el-form>
              </card>
            </el-collapse-item>
          </el-collapse>
        </el-tab-pane>

        <el-tab-pane name="claimdoc" :label="$t('Sənədlər')">
          <div>
            <claim-docs :readonly="true" v-if="item.id" :id="item.id"></claim-docs>
          </div>
        </el-tab-pane>

        <el-tab-pane
          name="expert"
          v-if="item.damageType !== 2 && claimParticipants.osDamageType !== 2"
          :label="$t('Qiymətləndirmə')"
        >
          <div>
            <div class="row">
              <div class="col-md-10 col-12">
                <div style="padding-bottom: 10px">
                  <span style="background-color:#8E9A9B; color: white; padding:5px;">
                    {{ "İş qiymətləndirməyə göndərilmişdir: " + techExpertStatus.createdBy }}
                  </span>
                </div>
              </div>
            </div>

            <div v-if="techExpertStatus">
              <assessments @refresh="getClaimTechExpert" :claimId="Number(id)" :readonly="true" />
            </div>
            <div v-if="techExpertStatus">
              <internal-evaluation @refresh="getData" :value="expertItem" :readonly="true" />
            </div>
            <div v-if="techExpertStatus && item.policyType === 1">
              <service-evaluation @refresh="getClaimTechExpert" :readonly="true" :value="expertItem" />
            </div>
            <div v-if="techExpertStatus">
              <indepentend-evaluation @refresh="getClaimTechExpert" :readonly="true" :value="expertItem" />
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane name="act" v-if="claimStatus >= 139" :label="$t('Hesab_məlumatları')">
          <div>
            <div class="row" style="margin-bottom: 10px;">
              <div class="col-10">
                <el-button size="small" type="warning" v-if="!act || (act && act.length == 0)">
                  <i class="fa-solid fa-play"></i>
                  {{ $t('Qəbul_et_və_başla') }}
                </el-button>

                <div v-else>
                  <span style="background-color:#8E9A9B; color: white; padding:5px;">
                    {{ "Hesab məlumatlarının daxil edilməsi başlanmışdır: " + act.createdBy }}
                  </span>
                  <br />
                </div>
              </div>
            </div>

            <bank-account-info
              :value="act"
              v-if="act && act.length !== 0"
              @refresh="getData"
              :actPrint="actPrint"
              :policyType="item.policyType"
            />
          </div>
          <br />
        </el-tab-pane>

        <el-tab-pane name="approve" :label="$t('Təsdiqlənmə')">
          <card v-if="rejectClaim && rejectClaim.length > 0 && claimStatus < 160">
            <div>
              <h5>{{ $t('Ödənişdən_geri_qaytarılıb') }}</h5>
              <br />

              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in rejectClaim"
                  :key="index"
                  :icon="activity.icon"
                  :type="activity.type"
                  :color="'#B3005E'"
                  :size="activity.size"
                  :timestamp="formatDateTime(activity.createDate)"
                >
                  <span style="font-size: var(--font-primary);">
                    {{ $t('Geri_qaytaran_1') }}
                  </span>
                  {{ activity.createUserName }}
                  <br />
                  <span style="font-size: var(--font-primary);">
                    {{ $t('Səbəb') }}:
                  </span>
                  {{ activity.reason }}
                </el-timeline-item>
              </el-timeline>
            </div>
          </card>

          <div class="row" style="margin-bottom: 10px;">
            <div class="col-10">
              <el-button type="warning" size="small" @click="handleApprove" v-if="claimStatus === 150">
                <i class="fa-solid fa-play"></i>
                {{ $t('Təsdiqlənməyə_göndər') }}
              </el-button>

              <div v-else>
                <!-- IMPORTANT: template içinde ?. ve ?? kullanma -->
                <span style="background-color:#8E9A9B; color:white; padding:5px;">
                  {{ 'Təsdiqlənməyə göndərilmişdir ' + (act && act.createdBy ? act.createdBy : '') }}
                </span>
              </div>
            </div>
          </div>

          <card>
            <div>
              <signers v-if="item && item.id" :value="item.id"></signers>
            </div>
          </card>
        </el-tab-pane>
      </el-tabs>
    </el-form>

    <participant ref="participant" @saved="getParticipants" />
    <report-participant ref="report" @saved="getParticipants" />
    <other-participant ref="otherParticipant" @saved="getParticipants" />
  </div>
</template>

<script>
import ClaimParticipantBase from "../components/ClaimParticipantBase.vue";
import InternalEvaluation from '../components/InternalEvaluation.vue';
import ServiceEvaluation from "../components/ServiceEvaluation.vue";
import IndepentendEvaluation from '../components/IndepentendEvaluation.vue';
import Phone from "../components/Phone.vue";
import StatusLabel from "../components/StatusLabel.vue";
import DamageCategories from "../components/DamageCategories.vue";
import BankAccountInfo from '../components/BankAccountInfo.vue';
import ClaimDocs from "../components/ClaimDocs.vue";
import Signers from "../components/Signers.vue";
import Assessments from "../components/Assessments.vue";
import MedDamageTypes from "../components/MedDamageTypes.vue";
import ActPrint from "../components/ActPrint.vue";
import Participant from "../components/Participant.vue";
import ParticipantCard from "../components/ParticipantCard.vue";
import OtherParticipantCard from "../components/OtherParticipantCard.vue";
import ClaimCard from "../components/ClaimCard.vue";
import AccidentBase from "../components/AccidentBase.vue";
import AccidentCommBase from "../components/AccidentCommBase.vue";
import ReportParticipant from "../components/ReportParticipant.vue";
import { GetParticipants, GetAccidentsByStatus } from "../../services/accident";
import { asanapi } from "../../services/sales";
import ActPrintZbt from "../components/ActPrintZbt.vue";
import ActPrintPayment from "../components/ActPrintPayment.vue";
import Titles from "../components/Titles.vue";
import { labelPosition, formatDateTime } from "../../services/helper";
import { GetClaimParticipant, GetClaimActPrint, CheckStatusCount, LastAssessmentStatus } from "../../services/common";
import { GetAccident, GetCommData } from "../../services/accident";
import {
  GetClaim,
  UpdateClaim,
  DeleteClaimDoc,
  SendToTechExpert,
  GetClaimTechExpert,
  CreateClaimAct,
  GetClaimAct,
  SendToLegalExpert,
  LastClaimStatus,
  SendToApprove,
  UpdateActApproval,
  LastActApprovalStatus,
  GetPaymentReject
} from "../../services/claim";
import OtherParticipant from "../components/OtherParticipant.vue";

export default {
  components: {
    ClaimDocs,
    ClaimParticipantBase,
    StatusLabel,
    InternalEvaluation,
    ServiceEvaluation,
    IndepentendEvaluation,
    Titles,
    DamageCategories,
    BankAccountInfo,
    Signers,
    Assessments,
    MedDamageTypes,
    Phone,
    AccidentBase,
    AccidentCommBase,
    Participant,
    ReportParticipant,
    ParticipantCard,
    OtherParticipant,
    OtherParticipantCard
  },
  props: {
    id: [Number],
    actId: [Number]
  },
  data() {
    return {
      activeName: "claim",
      loading: false,
      claimLoading: false,
      item: {},
      participants: [],
      claimdocs: [],
      accItem: {},
      search: "",
      claimParticipants: {},
      fileStatus: 0,
      techExpertStatus: {},
      legalExpertStatus: {},
      expertItem: {},
      actLoading: false,
      act: [],
      actPrint: {},
      claimStatus: {},
      oSdamageType: 1,
      medExpert: {},
      statusCount: 0,
      uid: this.$store.state.user.id,
      asanData: {
        Personal: {},
        Voen: {}
      },
      rejectClaim: [],
      assessmentStatus: null,
      printDialogVisible: false,
      comm: {},
      partloading: false,
      approvals: {},
      roles: this.$store.state.user.roles,
      rolesToCheck: ["Advisor", "Assistant Chairman", 'Director of ICD', 'Assistant Director of ICD'],
      actItem: {},
      approvalStatus: false,
      labelPosition: labelPosition
    };
  },
  computed: {
    paymentSumComputed: function () {
      const baseAmount = 5000;
      switch (this.item.medDamageType) {
        case 1:
          return (baseAmount * 15) / 100;
        case 2:
        case 3:
          return (baseAmount * 30) / 100;
        case 4:
          return (baseAmount * 100) / 100;
        case 5:
          return (baseAmount * 80) / 100;
        case 6:
          return (baseAmount * 60) / 100;
        case 7:
          return (baseAmount * 40) / 100;
        default:
          return 0;
      }
    },
    getPartPersonLabel() {
      if (this.item.damageCategoryId === 1) return null;
      if (this.item.damageCategoryId === 2) return this.$t('Xəsarətalanşəxs');
      return this.$t('Əmlaksahibininadı');
    },
    getIdentLabelName() {
      if (this.item.damageCategoryId === 1) return null;
      if (this.item.damageCategoryId === 2) return this.$t('XəsarətalanınFN');
      return this.$t('ƏmlaksahibininFN');
    },
    getPartPersonPhoneLabel() {
      if (this.item.damageCategoryId === 1) return null;
      if (this.item.damageCategoryId === 2) return this.$t('Xəsarətalanınəlaqənömrəsi');
      return this.$t('Əmlaksahibininəlaqənömrəsi');
    }
  },
  methods: {
    formatDateTime,

    getClaimActPrint() {
      GetClaimActPrint(this.id).then((response) => {
        if (response && response.data && response.data.data) {
          this.actPrint = response.data.data[0] ? response.data.data[0] : {};
        }
      });
    },

    getPaymentReject() {
      GetPaymentReject(this.id, 4).then((response) => {
        this.loading = false;
        if (response && response.data && response.data.data) {
          this.rejectClaim = response.data.data;
        }
      });
    },

    approve() {
      this.onSave(1);
    },
    reject() {
      this.onSave(2);
    },

    async onSave(status) {
      try {
        const { value } = await this.$prompt("Qeyd", this.$t('Təsdiqləyin'), {
          confirmButtonText: this.$t('Bəli'),
          cancelButtonText: "Xeyr"
        });

        if (status === 2 && (value === null || value.trim() === "")) {
          this.$message({ type: "warning", message: this.$t('Zəhmət_olmasa_səbəb_yazın') });
          return this.onSave(status);
        }

        this.approvals.id = this.actId;
        this.approvals.claimId = this.id;
        this.approvals.note = value;
        this.approvals.status = status;
        this.approvals.commandUserId = this.uid;

        const response = await UpdateActApproval(this.approvals);
        this.actloading = false;

        if (response && response.data) {
          if (!response.data.isSuccess) {
            this.$message({ type: "error", message: response.data.errors[0] });
          } else {
            this.$message({ type: "success", message: this.$t('Uğurlu_əməliyyat') });
            await this.lastActApprovalStatus();
            this.$router.push("/approval/main");
            this.getData();
          }
        } else {
          this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
        }
      } catch (error) {
        this.actloading = false;
        this.approvals.status = null;
        this.$message({ type: "info", message: "Xitam verildi" });
      }
    },

    radioChange(type) {
      let commChainAccidentOld = this.comm.commChainAccident;
      let commInjuredOld = this.comm.commInjured;

      if (type === "zbt") {
        if (this.comm.zbt === 1) {
          this.comm.commChainAccident = 0;
          this.comm.commInjured = 0;
          this.comm.vehicleCount = 2;
        }
      } else if (type === "commChainAccident") {
        this.comm.zbt = 0;
        this.comm.commChainAccident = commChainAccidentOld;
      } else if (type === 'commInjured') {
        this.comm.zbt = 0;
        this.comm.protocol = 0;
        this.comm.commInjured = commInjuredOld;
      } else {
        this.comm.commChainAccident = commChainAccidentOld;
        this.comm.commInjured = commInjuredOld;
      }
    },

    async print() {
      this.printDialogVisible = true;
    },

    getCommData() {
      this.commloading = true;
      GetCommData(this.item.accidentId).then((response) => {
        this.commloading = false;
        if (response && response.data && response.data.data) {
          this.comm = response.data.data;
        } else {
          this.$message({ type: "error", message: this.$t('Səhv_əməliyyat') });
        }
      });
    },

    checkStatusCount(id, status) {
      this.statusCount = 0;
      return new Promise((resolve, reject) => {
        CheckStatusCount(0, id, status).then(
          (response) => {
            if (response && response.data && response.data.data) {
              this.statusCount = response.data.data;
            }
            resolve(this.response);
          },
          (error) => reject(error)
        );
      });
    },

    editParticipant(id) {
      if (this.item.policyType === 1 && this.item.policyType) this.$refs["participant"].edit(id, false);
      else this.$refs["otherParticipant"].edit(id, false);
    },

    reportParticipant(id, accidentId, createUserId) {
      this.$refs["report"].edit(id, accidentId, createUserId);
    },

    getClaimTechExpert() {
      GetClaimTechExpert(this.id).then((response) => {
        if (response && response.data && response.data.data) {
          this.expertItem = response.data.data[0] ? response.data.data[0] : {};
          this.lastAssessmentStatus();
        }
      });
    },

    getClaimParticipants() {
      this.partloading = true;
      GetClaimParticipants(this.id).then((response) => {
        this.partloading = false;
        if (response && response.data && response.data.data) {
          this.claims = response.data.data;
        }
      });
    },

    getClaimAct() {
      GetClaimAct(this.id).then((response) => {
        if (response && response.data && response.data.data) {
          this.act = response.data.data[0] ? response.data.data[0] : [];
        }
      });
    },

    async getStatusTechExpert() {
      try {
        const response = await GetAccidentsByStatus(0, this.id, 70, this.uid);
        this.techExpertStatus = response && response.data && response.data.data && response.data.data[0]
          ? response.data.data[0]
          : null;
      } catch (error) {
        this.$message({ type: "error", message: this.$t('Texniki_ekspert_statusu_gətirilərkən_səhv_baş_verd') });
        this.techExpertStatus = null;
      }
    },

    lastAssessmentStatus() {
      return new Promise((resolve, reject) => {
        LastAssessmentStatus(this.id).then(
          (response) => {
            if (response && response.data && response.data.data) {
              this.assessmentStatus = response.data.data;
            }
            resolve(this.response);
          },
          (error) => reject(error)
        );
      });
    },

    async lastActApprovalStatus() {
      try {
        const response = await LastActApprovalStatus(this.id);
        if (response) this.approvalStatus = response.data;
        else this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
      } catch (error) {}
    },

    getParticipants() {
      GetParticipants(this.item.accidentId).then((response) => {
        this.partloading = false;
        if (response && response.data && response.data.data) {
          this.participants = response.data.data;
        }
      });
    },

    checkServiceCenterId() {
      if (!this.participants || this.participants.length === 0) return false;
      const typeOneParticipants = this.participants.filter((participant) => participant.participantType === 1);
      if (typeOneParticipants.length === 0) return false;
      const firstTypeOneParticipant = typeOneParticipants[0];
      return !!firstTypeOneParticipant.serviceCenterId;
    },

    saved() {
      this.getClaimDocs();
    },

    getAccident() {
      this.loading = true;
      GetAccident(this.item.accidentId).then((response) => {
        this.loading = false;
        if (response && response.data && response.data.data) {
          this.accItem = response.data.data[0] ? response.data.data[0] : null;
        } else {
          this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
        }
      });
    },

    async getData() {
      this.loading = true;
      try {
        const response = await GetClaim(this.id);
        this.loading = false;

        if (response && response.data && response.data.data) {
          this.item = response.data.data[0];

          await this.lastActApprovalStatus();
          this.getParticipants();
          this.getClaimParticipant();
          this.getStatusTechExpert();
          this.getClaimTechExpert();
          this.getClaimAct();
          this.getClaimActPrint();
          this.lastClaimStatus();
          this.lastAssessmentStatus();
          this.lastActApprovalStatus();
          this.getCommData();
          this.getAccident();
          this.getPaymentReject();
        } else {
          this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
        }
      } catch (error) {
        this.loading = false;
        this.$message({ type: "error", message: this.$t('Bir_səhv_baş_verdi') });
      }
    },

    getClaimParticipant() {
      GetClaimParticipant(this.id).then((response) => {
        if (response && response.data && response.data.data) {
          this.claimParticipants = response.data.data[0];
        } else {
          this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
        }
      });
    },

    lastClaimStatus() {
      LastClaimStatus(this.id).then((response) => {
        if (response) this.claimStatus = response.data;
        else this.$message({ type: "warning", message: this.$t('Səhv_əməliyyat') });
      });
    }
  },

  mounted() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
</style>
